import { Stack, SxProps, Theme, useTheme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { PropsWithChildren, RefObject } from 'react';

export interface DocumentChromeProps extends PropsWithChildren {
  sx?: SxProps<Theme>;
  shadowSx?: SystemStyleObject<Theme>;
  shouldCenterContent: boolean;
  scrollContainerRef?: RefObject<HTMLDivElement | null>;
}

export type DocumentChromeOverrides = Pick<
  DocumentChromeProps,
  'sx' | 'shadowSx'
>;

export function DocumentChrome({
  sx = {},
  shadowSx = {},
  shouldCenterContent,
  scrollContainerRef,
  children,
}: DocumentChromeProps) {
  const theme = useTheme();

  return (
    <Stack
      ref={scrollContainerRef}
      sx={sx}
      height="100%"
      data-name="DocumentChrome"
    >
      <Stack
        data-name="DocumentChrome-shadow"
        height="100%"
        sx={{
          boxShadow: theme.palette.shadows.xxxl,
          justifyContent: shouldCenterContent ? 'center' : 'start',
          ...shadowSx,
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
}
